import React from "react";
import styled from "styled-components";
import logo from "../img/logo2.png";
import { useNavigate } from "react-router-dom";

const Div = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(
    to left bottom,
    #98cfa1,
    #91ce9f,
    #8acd9e,
    #82cb9c,
    #7aca9b,
    #72c898,
    #69c594,
    #60c391,
    #55c08a,
    #48bc84,
    #3ab97d,
    #29b576
  );
`;

const MainHead = styled.h1`
  font-family: "parkyongjoon";
  font-size: 4em;
  color: white;
`;

const Iframe = styled.iframe`
  margin: 10px 0;
`;

const VideoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 90%;
  height: 70%;
  display: flex;
  border: none;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 60px;
  margin-top: 10px;
`;

const Logo = styled.img`
  padding: 10px 20px;
  height: 90px;
`;

const BottomDiv = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
`;

const NextButton = styled.button`
  border: none;
  background: none;

  font-weight: bold;
  font-size: 1.5rem;

  margin-left: 10px;
  color: #ff6b54;
  font-family: "parkyongjoon";
  cursor: pointer;
`;

const TriangleButton = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 15px 10px 0;
  border-color: transparent #ff6b54 transparent #ff6b54;
  margin-right: 5px;
`;

const NextDiv = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 20px;
`;

function MenualKakao() {
  const navigate = useNavigate();
  return (
    <Div>
      <MainHead>카카오톡 사용법</MainHead>
      <VideoBox>
        <Iframe
          title="youtube"
          type="text/html"
          width="80%"
          height="65%"
          src={"https://youtube.com/embed/bWc_nPjGwyU"}
          allow="fullscreen"
        ></Iframe>
      </VideoBox>
      <BottomDiv>
        <Logo src={logo} alt="로고"></Logo>
        <NextDiv>
          <TriangleButton></TriangleButton>
          <NextButton onClick={() => navigate("/menu")}>다봤어요!</NextButton>
        </NextDiv>
      </BottomDiv>
    </Div>
  );
}

export default MenualKakao;
